"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _react = _interopRequireDefault(require("react"));
var _Button = require("@ccw-pwa-ui/Button");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
require("../styles/RepalceFilterComponent.css");
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
const RepalceFilterComponent = _ref => {
  let {
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    addDateContent,
    InstallationDateTxt,
    saveContinueBtnTitle,
    saveContinueBtnDisabled,
    saveContinueBtnClick,
    value,
    onchange,
    id,
    modelNumber
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "repalce-filter-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _index.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "replace-filter-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "replace-filter-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "replace-filter-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "relace-filter-content"
  }, /*#__PURE__*/_react.default.createElement("p", null, addDateContent)), /*#__PURE__*/_react.default.createElement("div", {
    className: "replace-filter-label"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: modelNumber
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "replace-filter-label"
  }, /*#__PURE__*/_react.default.createElement("label", null, InstallationDateTxt)), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "date-picker",
    className: "replace-filter-date-picker"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    placeholderText: "Select Date",
    className: "replace-filter-date",
    selected: value,
    onChange: date => onchange(id, date),
    maxDate: new Date()
    // minDate={moment().subtract(1, "months")}
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.Union.default,
    alt: "",
    className: "email-icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "replace-filter-btn",
    "data-testid": "replace-filter-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: saveContinueBtnTitle,
    onClick: saveContinueBtnClick,
    disabled: saveContinueBtnDisabled
  })))));
};
var _default = exports.default = RepalceFilterComponent;